export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      dark: '#1C1C1C',
      // Vermelho de marca EasyPallet — usar via <VaButton color="brand"> nos CTAs do Service Desk.
      // NÃO sobrescreve `primary` (azul), que vale para todo o CRM.
      brand: '#fa2b00',
    },
    dark: {
      backgroundPrimary: '#222222',
      backgroundSecondary: '#282828',
      backgroundCardPrimary: '#2c2c2c',
      backgroundCardSecondary: '#262626',
      dark: '#2c2c2c',
      brand: '#fa2b00',
    },
  },
}
